import { useEffect } from 'react';
import ReactGA from 'react-ga4';

import { isStandalone } from '@/lib/helpers/urlParams.ts';
import { useBookingStore } from '@/store/useBookingStore';

import styles from './ConfirmationScreen.module.css';

export const ConfirmationScreen = () => {
  const { appointment } = useBookingStore();
  const providerImg = appointment?.provider?.provider_profile_image_url;
  const providerName = appointment?.provider?.name;

  useEffect(() => {
    if (import.meta.env.VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID) {
      ReactGA.send({
        hitType: 'pageview',
        page: window.location.pathname,
        title: 'Confirmation Screen',
      });
    }
  }, []);

  return (
    <section className={styles.confirmationScreen}>
      <img
        className={providerImg ? styles.confirmationProviderImg : styles.confirmationCheckmark}
        src={providerImg ?? '/checkmark.png'}
        alt={providerName}
      />
      <p className={styles.confirmationTitle}>Appointment created successfully</p>
      <p>{appointment?.description}</p>
      <p>
        {isStandalone()
          ? 'Thank you for your submission, have a great day!'
          : 'You can continue safely.'}
      </p>
    </section>
  );
};
